import { Outlet } from "react-router-dom";
import MobileNavigationMenu from "./mobile/MobileNavigationMenu";
import DesktopNavigationMenu from "./desktop/DesktopNavigationMenu";
import ProfileDropdownMenu from "./profile/ProfileDropdownMenu";
import usePermissions from "../../hooks/usePermissions";
import useLoading from "../../shared/components/loading/useLoading";
import LoadingSpinner from "../../shared/components/loading/LoadingSpinner";
import { useContext } from "react";
import NavbarItemsContext from "../../contexts/navbarItemsContext";

const PrivateLayout = () => {
  const { loading } = useLoading();
  const context = useContext(NavbarItemsContext);
  const permissions = usePermissions();
  const sections = permissions.getNavbarSections();

  const onItemClickHandler = (selectedIndexClicked) => {
    context.setSelectedIndex(selectedIndexClicked);
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex min-h-screen w-full flex-col">
        <header className="sticky top-0 flex h-16 items-center gap-5 border-b bg-background px-4 md:px-6 z-40">
          <DesktopNavigationMenu
            sections={sections}
            selectedIndex={context.selectedIndex}
            onItemClick={onItemClickHandler}
          />
          <MobileNavigationMenu
            sections={sections}
            selectedIndex={context.selectedIndex}
            onItemClick={onItemClickHandler}
          />
          <div className="flex w-full items-center gap-4 md:ml-auto md:gap-2 lg:gap-4">
            <div className="ml-auto flex-1 sm:flex-initial"></div>
            <ProfileDropdownMenu />
          </div>
        </header>
        <main className="flex-1 h-full flex-col bg-muted/40 sm:gap-4 sm:py-4">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default PrivateLayout;
